import { isEqual, isArray ,sortBy} from 'lodash';
export const objectHasProperty = (obj, prop) => {
	let result = false;

	if (obj && typeof obj === 'object') {
		result = Object.prototype.hasOwnProperty.call(obj, prop);
	}

	return result;
};

export const areEqualElements = (element1, element2) => {
	if (isArray(element1) && isArray(element2)) {
        return isEqual(sortBy(element1), sortBy(element2));
    }
    return isEqual(element1, element2);
};